import React, { useEffect, useState } from "react";
import { FiSave } from "react-icons/fi";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import Footer from "../shared/Footer";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const SettingGoogleForm = () => {
  // API tablosundaki tüm alanları tek bir state içinde tut
  const [apiSettings, setApiSettings] = useState({
    mailjet_title: "",
    mailjet_secret: "",
    mailjet_api: "",
    s3_cdn_key: "",
    s3_cdn_secret: "",
    s3_cdn_endpoint: "",
    s3_cdn_bucket: "",
    s3_cdn_region: "",
    s3_cdn_path: "",
    paytr_merchant_id: "",
    paytr_merchant_key: "",
    paytr_merchant_salt: "",
    google_analytics_api: "",
  });

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;


  // API verilerini çekme fonksiyonu (useEffect'ten önce tanımlanmalı)
  const fetchApiData = async () => {
    try {
      const resp = await axios.get(`${BASE_URL}/api/settings/1`); // id=1 olan kaydı alıyoruz
      setApiSettings((prevState) => ({
        ...prevState,
        ...resp.data, // API'den gelen değerleri al, boş olanları koru
      }));
    } catch (err) {
      console.error("API verisi çekme hatası:", err);
      toast.error("API ayarları alınamadı!");
    }
  };

  // İlk render’da verileri çek
  useEffect(() => {
    fetchApiData();
  }, []);

  // Input değişikliklerini handle etme
  const handleChange = (e) => {
    const { name, value } = e.target;
    setApiSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Kaydet butonuna basınca API'yi güncelle
  const handleSave = async () => {
    try {
      await axios.put(`${BASE_URL}/api/settings/1`, apiSettings);
      toast.success(getText("SUCCESS_API_UPDATED"));
      fetchApiData(); // Güncellenmiş verileri tekrar çek
    } catch (error) {
      console.error("API Bilgileri kaydedilemedi:", error);
      toast.error("Kayıt hatası oluştu!");
    }
  };

  return (
    <div className="content-area setting-form">
    <ToastContainer />
    <PerfectScrollbar>
      <PageHeaderSetting />
      <div className="content-area-body">
          <div className="card-body">

      <div className="card card-body mb-4">
        {/* ========== GOOGLE ANALYTICS API ========== */}
     
        <div className="mb-3">
          <label className="form-label fw-bold">{getText("LABEL_GOOGLE_ANALYTICS_API")}</label>
          <textarea
            className="form-control"
            name="google_analytics_api"
            rows="8"
            value={apiSettings.google_analytics_api || ""}
            onChange={handleChange}
          />
        </div>

        {/* KAYDET BUTONU */}
        <div className="d-flex justify-content-center">
          <button className="btn btn-primary" onClick={handleSave}>
            <FiSave className="me-2" /> {getText("SAVE_BTN")}
          </button>
        </div>
      </div>
  
      </div>
      </div>
      
      
      </PerfectScrollbar>
    </div>
  );
};

export default SettingGoogleForm;
